import { createReducer } from "@reduxjs/toolkit";
import {
  DAM_STATUSES_GET_ALL,
  DAM_STATUSES_GET_BY_ID,
  DAM_STATUSES_ADD,
  DAM_STATUSES_UPDATE,
  DAM_STATUSES_DELETE,
} from "./action";
import { DamStatus } from "src/types/damStatus";

export type DamStatusState = {
  damStatuses: DamStatus[];
  selectedDamStatus: DamStatus | null;
};

export const initialState: DamStatusState = {
  damStatuses: [],
  selectedDamStatus: null,
};

const damStatusReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(DAM_STATUSES_GET_ALL, (state, action) => {
      state.damStatuses = action.payload.damStatuses;
    })
    .addCase(DAM_STATUSES_GET_BY_ID, (state, action) => {
      state.selectedDamStatus = action.payload.damStatus;
    })
    .addCase(DAM_STATUSES_ADD, (state, action) => {
      state.damStatuses.push(action.payload.damStatus);
    })
    .addCase(DAM_STATUSES_UPDATE, (state, action) => {
      const updated = action.payload.damStatus;
      state.damStatuses = state.damStatuses.map((s) =>
        s.damStatusId === updated.damStatusId ? updated : s
      );
    })
    .addCase(DAM_STATUSES_DELETE, (state, action) => {
      state.damStatuses = state.damStatuses.filter(
        (s) => s.damStatusId !== action.payload.damStatusId
      );
    })
);

export default damStatusReducer;
